import { Injectable, signal } from '@angular/core'
import { MaintenanceServiceItem } from '../maintenance-services-tab.type'

@Injectable({ providedIn: 'root' })
export class MaintenanceServicesTabStateService {
  public readonly items = signal<MaintenanceServiceItem[]>([])

  public constructor() {
    window.addEventListener('clearMaintenanceServicesVariables', () => this.reset())
  }

  public setItems(items: MaintenanceServiceItem[]): void {
    this.items.set(items)
  }

  public reset(): void {
    this.items.set([])
  }
}
